import type { ClientAuthConfig } from '@mntn-dev/authentication-types'

import { MockModel } from './mock-model.ts'

export const MockClientAuthConfig = MockModel<ClientAuthConfig>(() => {
  return {
    apiBaseUrl: 'https://api.base.url',
    passBaseUrl: 'https://pass.base.url',
    debug: false,
    signInUrl: 'https://pass.base.url/sign-out',
    clerk: {
      clerkFrontendUrl: 'https://clerk.frontend.url',
      publishableKey: 'test-publishable-key',
      signInUrl: '/sign-in',
      isSatellite: true,
      domain: 'test.domain.com',
      debug: false,
    },
    mntn: {
      debug: false,
    },
  } satisfies ClientAuthConfig
})
